(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /**
   * Returns the validation message key for a contact form field.
   * @param {HTMLInputElement | HTMLTextAreaElement} field
   * @param {DOMStringMap} messages
   * @returns {string | null}
   */
  const getContactFieldErrorMessage = (field, messages) => {
    const fieldType = field.dataset.contactField;
    const value = field.value.trim();

    if (fieldType === 'name') {
      return value === '' ? messages.nameBlank : null;
    }

    if (fieldType === 'comment') {
      return value === '' ? messages.commentBlank : null;
    }

    if (fieldType === 'email') {
      if (value === '') return messages.emailBlank;
      if (!EMAIL_PATTERN.test(value)) return messages.emailInvalid;
      return null;
    }

    if (fieldType === 'phone' && value !== '' && !field.checkValidity()) {
      return messages.phoneInvalid;
    }

    return null;
  };

  /**
   * Shows or clears the inline error for a contact form field.
   * @param {HTMLInputElement | HTMLTextAreaElement} field
   * @param {string | null} message
   */
  const setContactFieldError = (field, message) => {
    const errorElement = document.getElementById(`${field.id}-error`);
    if (!errorElement) return;

    if (message) {
      errorElement.textContent = message;
      errorElement.hidden = false;
      field.setAttribute('aria-invalid', 'true');
      return;
    }

    errorElement.textContent = '';
    errorElement.hidden = true;
    field.removeAttribute('aria-invalid');
  };

  /**
   * Validates every field in a contact form.
   * @param {HTMLFormElement} form
   * @returns {boolean}
   */
  const validateContactForm = (form) => {
    const contactForm = form.closest('.contact-form');
    const messages = contactForm?.dataset ?? {};
    const fields = form.querySelectorAll('[data-contact-field]');
    let isValid = true;

    fields.forEach((field) => {
      const message = getContactFieldErrorMessage(field, messages);
      setContactFieldError(field, message);
      if (message) isValid = false;
    });

    const errorSummary = form.querySelector('.contact-form__error-summary');
    if (errorSummary) {
      errorSummary.hidden = isValid;
    }

    return isValid;
  };

  document.querySelectorAll('.contact-form__form').forEach((form) => {
    const contactForm = form.closest('.contact-form');

    form.addEventListener('submit', (event) => {
      if (!validateContactForm(form)) {
        event.preventDefault();
        const firstInvalidField = form.querySelector('[aria-invalid="true"]');
        firstInvalidField?.focus();
      }
    });

    form.querySelectorAll('[data-contact-field]').forEach((field) => {
      field.addEventListener('input', () => {
        const message = getContactFieldErrorMessage(field, contactForm?.dataset ?? {});
        setContactFieldError(field, message);
      });

      field.addEventListener('blur', () => {
        const message = getContactFieldErrorMessage(field, contactForm?.dataset ?? {});
        setContactFieldError(field, message);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tolstoy-stories"] && !Shopify.designMode) return;
  try {
    /**
 * Returns true when Tolstoy has painted real story content (not its built-in loader).
 * @param {Element} root
 * @returns {boolean}
 */
const tolstoyHasContent = (root) => {
  const host = root.querySelector('tolstoy-widget') || root;
  const statusLoader = host.querySelector('[role="status"]');
  if (statusLoader && !host.querySelector('video, img, iframe, canvas, button[aria-label]')) {
    return false;
  }
  if (host.querySelector('img, video, iframe, canvas')) return true;
  return (host.textContent || '').replace(/\s+/g, '').length > 0;
};

/**
 * Reserves layout with a skeleton until Tolstoy content arrives, then collapses if empty.
 * INP risk: low — observer only toggles data attributes; no layout reads.
 * @param {Element} root
 */
const initTolstoyStoriesSkeleton = (root) => {
  if (!root || !root.hasAttribute('data-tolstoy-loading')) return;
  if (root.hasAttribute('data-tolstoy-skeleton-ready')) return;
  root.setAttribute('data-tolstoy-skeleton-ready', '');

  let settled = false;

  /**
   * @param {boolean} empty
   */
  const settle = (empty) => {
    if (settled) return;
    settled = true;
    root.toggleAttribute('data-tolstoy-loading', false);
    root.toggleAttribute('data-tolstoy-empty', empty);
    observer.disconnect();
    window.clearTimeout(timeoutId);
  };

  const observer = new MutationObserver(() => {
    if (tolstoyHasContent(root)) settle(false);
  });

  observer.observe(root, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  if (tolstoyHasContent(root)) {
    settle(false);
    return;
  }

  const timeoutId = window.setTimeout(() => {
    settle(!tolstoyHasContent(root));
  }, 10000);
};

const initAllTolstoyStoriesSkeletons = () => {
  document.querySelectorAll('.tolstoy-stories-block[data-tolstoy-loading]').forEach(initTolstoyStoriesSkeleton);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllTolstoyStoriesSkeletons, { once: true });
} else {
  initAllTolstoyStoriesSkeletons();
}

document.addEventListener('shopify:section:load', initAllTolstoyStoriesSkeletons);
  } catch(e) { console.error(e); }
})();

})();
